define('components/asset-player/collections/assets',[
    'components/boilerplate/collections/base',
    'components/asset-player/models/asset',
    'components/asset-player/models/media-file'
], function (Base, Asset, MediaFile) {
    "use strict";

    var Assets,
        supportedMediaFileTypeIds = [
            // Images
            MediaFile.Type.GENERAL_IMAGES,
            MediaFile.Type.SMALL_IMAGES,
            MediaFile.Type.MEDIUM_IMAGES,
            MediaFile.Type.LARGE_IMAGES,

            // Audio
            MediaFile.Type.MP3,

            // Video
            MediaFile.Type['300K_MP4'],
            MediaFile.Type['2MB_MP4'],

            // HTML5 (interactives)
            MediaFile.Type.HYPER_TEXT_MARKUP_LANGUAGE_5,

            // PDFs
            MediaFile.Type.GENERAL_PDFS,

            // WebVTT
            MediaFile.Type.WEB_VTT
        ];

    Assets = Base.extend({
        "model": Asset,

        "requests": {
            "current": null,
            "pending": null
        },

        "url": window.initData.appUrl + "/api:assets/list",

        "retrieveAssets": function (assetList) {
            var assets = {
                    "all": [],
                    "cached": [],
                    "fresh": []
                },
                deferred = new $.Deferred(),
                retVal;

            retVal = {
                "assets": assets,
                "promise": deferred.promise()
            };

            // Add assets to the collection
            // Note if the same assets already exist they will remain
            // unaffected.
            this.add(assetList);

            _.each(assetList, function (assetData) {
                var assetCached,
                    asset = this.findWhere({
                        "guid": assetData.guid.toLowerCase()
                    });

                if (!asset) {
                    return;
                }

                assetCached = asset.get('cached');

                assets.all.push(asset);
                assets[assetCached ? 'cached' : 'fresh'].push(asset);
            }, this);

            // Fetch the assets and resolve when done.
            this.fetch()
                .fail(function () {
                    deferred.rejectWith(this, [assets, this]);
                })
                .done(function () {
                    deferred.resolveWith(this, [assets, this]);
                });

            return retVal;
        },

        "fetch": function (xhrOpts) {
            var deferred,
                rejectDeferred,
                resolveDeferred,
                updateRequestQueue;

            // Either re-use an existing pending request deferred object or create a new one
            deferred = this.requests.pending || new $.Deferred();

            if (this.requests.current) {
                // A request is already in progress.
                // Set the pending request deferred object and return the promise.
                this.requests.pending = deferred;
                return deferred.promise();
            }

            // Ready for a fresh request.
            // Either take on a pending request or use a new deferred object
            // for the assets request.
            this.requests.current = deferred;
            this.requests.pending = null;

            updateRequestQueue = _.bind(function () {
                // Stop listening to events
                this.stopListening(this, 'error sync');

                // Current request complete (success/fail).
                // Clear the current request and resolve the deferred object.
                this.requests.current = null;

                if (this.requests.pending) {
                    // There are more assets requests pending in the
                    // queue. We need to fetch again.
                    this.fetch();
                }
            }, this);

            rejectDeferred = _.bind(function () {
                // Reject the fetch deferred object
                deferred.rejectWith(this, [this]);

                updateRequestQueue();
            }, this);

            resolveDeferred = _.bind(function () {
                // Resolve the fetch deferred object
                deferred.resolveWith(this, [this]);

                updateRequestQueue();
            }, this);

            xhrOpts = _.extend(this.getRequestOptions(), xhrOpts);

            if (!xhrOpts.data.assetGuids.length) {
                // Either there are no assets to fetch or all assets
                // being requested are already cached.
                // Resolve the deferred object and return the promise.
                resolveDeferred();
                return deferred.promise();
            }

            this.listenToOnce(this, 'error', rejectDeferred);
            this.listenToOnce(this, 'sync', resolveDeferred);

            // Do the actual fetch
            Backbone.Collection.prototype.fetch.call(this, xhrOpts);

            // Return the fetch promise
            return deferred.promise();
        },

        "getRequestOptions": function () {
            return {
                "crossDomain": true,

                "dataType": "json",

                "data": {
                    "assetGuids": this.getNonCachedGuidList().join(','),
                    "mediaFileTypeIds": supportedMediaFileTypeIds.join(','),
                    "returnMediaFiles": true,
                    "returnThumbnails": true
                },

                "method": "GET",

                "remove": false,

                "url": this.url,

                "xhrFields": {
                    "withCredentials": true
                }
            };
        },

        "getNonCachedGuidList": function () {
            return this.reduce(function (value, asset) {
                if (!asset.get('cached')) {
                    value.push(asset.get('guid'));
                }
                return value;
            }, []);
        },

        "parse": function (response) {
            var assets = [];

            _.each(response.DATA, function (assetData) {
                var asset = this.findWhere({
                        "guid": assetData.guid.toLowerCase()
                    });

                if (!asset) {
                    return;
                }

                assetData.cached = true;
                assetData.mediaFiles = [];

                _.each(supportedMediaFileTypeIds, function (typeId) {
                    var mediaFileKey = 'mediaFile' + typeId,
                        mediaFileUrl = assetData[mediaFileKey];

                    // We are generating a `MediaFile` model
                    // for each media-file but if we don't
                    // delete the corresponding property from
                    // `assetData` it will show up in the asset's
                    // list of attributes as well. We want to keep
                    // this as tight as possible.
                    delete assetData[mediaFileKey];

                    if (mediaFileUrl) {
                        assetData.mediaFiles.push({
                            "assetGuid": assetData.guid,
                            "typeId": typeId,
                            "url": mediaFileUrl
                        });
                    }
                });

                assets.push(assetData);
            }, this);

            return assets;
        }
    });

    // return instance object
    return new Assets();
});

